import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"icon-mail\"><path d=\"M20 1.845v12.308c0 1.02-.792 1.846-1.758 1.846H1.758C.786 16 0 15.167 0 14.153V1.845C0 .828.79 0 1.758 0h16.484C19.214 0 20 .832 20 1.845zM2.006 1.23l8.031 8.363L18 1.23zm4.81 6.741L1.171 2.095v11.803zm11.183 6.798l-5.616-5.9-1.93 2.027a.567.567 0 0 1-.827.002l-1.978-2.06L2 14.768zM18.83 2.1L13.21 8l5.617 5.898z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol